import { Link } from 'react-router-dom';

export default function PublicsAccompagnesPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-br from-slate-50 to-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <div className="inline-block">
              <span className="text-sm font-semibold tracking-wider text-orange-500 uppercase">Pour qui ?</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight font-serif">
              Publics accompagnés
            </h1>
            
            <p className="text-xl text-slate-600 leading-relaxed">
              PULSAR FC s'adresse à tous ceux qui souhaitent développer leurs compétences, s'intégrer socialement et professionnellement, ou bénéficier d'un accompagnement personnalisé dans leur parcours de vie.
            </p>
          </div>
        </div>
      </section>

      {/* Publics en Alternance */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12 max-w-6xl">
          
          {/* Public 1 - Demandeurs d'emploi */}
          <div className="grid lg:grid-cols-5 gap-12 items-center mb-24">
            <div className="lg:col-span-2 rounded-3xl overflow-hidden shadow-2xl h-96">
              <img 
                src="https://public.readdy.ai/ai/img_res/cf619ec9b8d1eb04dddda604330d8929.jpg"
                alt="Demandeurs d'emploi"
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="lg:col-span-3 space-y-6">
              <div className="inline-block px-4 py-2 bg-orange-100 text-orange-600 rounded-full text-sm font-semibold">
                Insertion professionnelle
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif">Demandeurs d'emploi</h2>
              
              <p className="text-lg text-slate-600 leading-relaxed">
                Vous êtes à la recherche d'un emploi et souhaitez bénéficier d'un accompagnement personnalisé ? PULSAR FC vous aide à construire votre projet professionnel, développer vos compétences et optimiser vos démarches de recherche d'emploi.
              </p>
              
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-slate-900">Ce que nous vous proposons :</h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Bilan de compétences et définition de projet professionnel</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Ateliers CV, lettre de motivation et préparation aux entretiens</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Formations qualifiantes et certifiantes</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Mise en relation avec des employeurs partenaires</span>
                  </li>
                </ul>
              </div>
              
              <Link 
                to="/contact" 
                className="inline-block px-10 py-4 bg-slate-900 text-white rounded-full font-semibold hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Être accompagné
              </Link>
            </div>
          </div>

          {/* Public 2 - Bénéficiaires RSA */}
          <div className="grid lg:grid-cols-5 gap-12 items-center mb-24">
            <div className="lg:col-span-3 space-y-6 order-2 lg:order-1">
              <div className="inline-block px-4 py-2 bg-slate-100 text-slate-700 rounded-full text-sm font-semibold">
                Accompagnement social
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif">Bénéficiaires du RSA</h2>
              
              <p className="text-lg text-slate-600 leading-relaxed">
                Vous percevez le RSA et souhaitez vous engager dans un parcours d'insertion ? PULSAR FC vous accompagne dans la construction d'un projet professionnel adapté à votre situation et vous aide à lever les freins à l'emploi.
              </p>
              
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-slate-900">Notre accompagnement :</h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Diagnostic global de votre situation (sociale, professionnelle, personnelle)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Accompagnement dans les démarches administratives</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Ateliers de remobilisation et de confiance en soi</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Orientation vers des formations adaptées</span>
                  </li>
                </ul>
              </div>
              
              <Link 
                to="/contact" 
                className="inline-block px-10 py-4 bg-slate-900 text-white rounded-full font-semibold hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Prendre contact
              </Link>
            </div>
            
            <div className="lg:col-span-2 rounded-3xl overflow-hidden shadow-2xl h-96 order-1 lg:order-2">
              <img 
                src="https://readdy.ai/api/search-image?query=social%20worker%20helping%20person%20in%20need%20with%20administrative%20support%20in%20welcoming%20office%20showing%20compassion%20guidance%20and%20social%20assistance%20for%20vulnerable%20people&width=700&height=800&seq=rsa-beneficiaries-public&orientation=portrait"
                alt="Bénéficiaires RSA"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Public 3 - Publics Vulnérables */}
          <div className="grid lg:grid-cols-5 gap-12 items-center mb-24">
            <div className="lg:col-span-2 rounded-3xl overflow-hidden shadow-2xl h-96">
              <img 
                src="https://readdy.ai/api/search-image?query=compassionate%20counselor%20supporting%20vulnerable%20person%20in%20warm%20welcoming%20space%20showing%20empathy%20care%20and%20personalized%20psychological%20support%20for%20fragile%20populations&width=700&height=800&seq=vulnerable-populations-public&orientation=portrait"
                alt="Publics vulnérables"
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="lg:col-span-3 space-y-6">
              <div className="inline-block px-4 py-2 bg-orange-100 text-orange-600 rounded-full text-sm font-semibold">
                Soutien psychologique
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif">Publics Vulnérables &amp; Discriminés</h2>
              
              <p className="text-lg text-slate-600 leading-relaxed">
                Vous traversez une période difficile, vous êtes victime de discriminations ou vous avez besoin d'un soutien psychologique ? PULSAR FC vous offre un espace d'écoute bienveillant et un accompagnement adapté à vos besoins.
              </p>
              
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-slate-900">Nous sommes là pour vous :</h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Écoute active et soutien psychologique</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Accompagnement dans la reconstruction personnelle</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Orientation vers les structures spécialisées</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Lutte contre les discriminations et défense des droits</span>
                  </li>
                </ul>
              </div>
              
              <Link 
                to="/contact" 
                className="inline-block px-10 py-4 bg-slate-900 text-white rounded-full font-semibold hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Demander de l'aide
              </Link>
            </div>
          </div>

          {/* Public 4 - Primo-arrivants */}
          <div className="grid lg:grid-cols-5 gap-12 items-center mb-24">
            <div className="lg:col-span-3 space-y-6 order-2 lg:order-1">
              <div className="inline-block px-4 py-2 bg-slate-100 text-slate-700 rounded-full text-sm font-semibold">
                Intégration
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif">Primo-arrivants &amp; Migrants</h2>
              
              <p className="text-lg text-slate-600 leading-relaxed">
                Vous venez d'arriver en France et souhaitez vous intégrer ? PULSAR FC vous accompagne dans l'apprentissage de la langue française, la découverte des valeurs républicaines et votre insertion dans la société française.
              </p>
              
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-slate-900">Nos services :</h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Cours de français langue étrangère (FLE) tous niveaux</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Formation civique et citoyenneté</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Aide aux démarches administratives</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Accompagnement vers l'emploi et la formation</span>
                  </li>
                </ul>
              </div>
              
              <Link 
                to="/contact" 
                className="inline-block px-10 py-4 bg-slate-900 text-white rounded-full font-semibold hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                S'inscrire aux cours
              </Link>
            </div>
            
            <div className="lg:col-span-2 rounded-3xl overflow-hidden shadow-2xl h-96 order-1 lg:order-2">
              <img 
                src="https://readdy.ai/api/search-image?query=diverse%20newcomers%20and%20migrants%20learning%20french%20language%20in%20welcoming%20classroom%20showing%20integration%20hope%20and%20cultural%20adaptation%20in%20bright%20educational%20space&width=700&height=800&seq=newcomers-migrants-public&orientation=portrait"
                alt="Primo-arrivants"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Public 5 - Jeunes */}
          <div className="grid lg:grid-cols-5 gap-12 items-center mb-24">
            <div className="lg:col-span-2 rounded-3xl overflow-hidden shadow-2xl h-96">
              <img 
                src="https://readdy.ai/api/search-image?query=young%20people%20in%20digital%20literacy%20and%20citizenship%20workshop%20learning%20about%20social%20media%20safety%20and%20civic%20values%20in%20modern%20bright%20space%20showing%20youth%20engagement&width=700&height=800&seq=youth-public-education&orientation=portrait"
                alt="Jeunes"
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="lg:col-span-3 space-y-6">
              <div className="inline-block px-4 py-2 bg-orange-100 text-orange-600 rounded-full text-sm font-semibold">
                Éducation &amp; prévention
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif">Jeunes &amp; Étudiants</h2>
              
              <p className="text-lg text-slate-600 leading-relaxed">
                Vous êtes jeune et souhaitez développer votre esprit critique, comprendre les enjeux citoyens ou vous préparer à votre insertion professionnelle ? PULSAR FC propose des ateliers adaptés aux jeunes générations.
              </p>
              
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-slate-900">Nos ateliers pour les jeunes :</h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Éducation aux médias et à l'information (fake news, réseaux sociaux)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Citoyenneté et engagement associatif</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Orientation professionnelle et découverte des métiers</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Développement des soft skills</span>
                  </li>
                </ul>
              </div>
              
              <Link 
                to="/contact" 
                className="inline-block px-10 py-4 bg-slate-900 text-white rounded-full font-semibold hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Participer aux ateliers
              </Link>
            </div>
          </div>

          {/* Public 6 - Institutions */}
          <div className="grid lg:grid-cols-5 gap-12 items-center">
            <div className="lg:col-span-3 space-y-6 order-2 lg:order-1">
              <div className="inline-block px-4 py-2 bg-slate-100 text-slate-700 rounded-full text-sm font-semibold">
                Partenariats professionnels
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif">Institutions &amp; Entreprises</h2>
              
              <p className="text-lg text-slate-600 leading-relaxed">
                Vous êtes une collectivité, une administration, une entreprise ou une association et souhaitez développer des actions d'inclusion, de formation ou de responsabilité sociale ? PULSAR FC vous accompagne dans vos projets.
              </p>
              
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-slate-900">Nos prestations :</h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Formations sur mesure pour vos équipes</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Conseil en politique d'inclusion et de diversité</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Accompagnement de projets à impact social</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-slate-900 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-slate-700">Évaluation et mesure d'impact</span>
                  </li>
                </ul>
              </div>
              
              <Link 
                to="/contact" 
                className="inline-block px-10 py-4 bg-slate-900 text-white rounded-full font-semibold hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Devenir partenaire
              </Link>
            </div>
            
            <div className="lg:col-span-2 rounded-3xl overflow-hidden shadow-2xl h-96 order-1 lg:order-2">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20business%20partners%20in%20strategic%20meeting%20discussing%20corporate%20social%20responsibility%20and%20institutional%20collaboration%20in%20modern%20conference%20room&width=700&height=800&seq=institutions-partners-public&orientation=portrait"
                alt="Institutions et entreprises"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

        </div>
      </section>

      {/* Tous concernés */}
      <section className="py-24 bg-slate-50">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif">Tous concernés par l'inclusion</h2>
            <p className="text-xl text-slate-600 leading-relaxed">
              Quel que soit votre profil, votre situation ou vos besoins, PULSAR FC est à votre écoute pour construire ensemble un parcours adapté. L'inclusion est l'affaire de tous, et chacun a sa place dans notre société.
            </p>
            <div className="grid md:grid-cols-3 gap-6 pt-8">
              <div className="bg-white rounded-2xl p-6 text-center space-y-3">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-user-smile-line text-3xl text-orange-500"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900">Accessibilité</h4>
                <p className="text-slate-600">Nos services sont ouverts à tous, sans discrimination</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center space-y-3">
                <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-hand-heart-line text-3xl text-slate-900"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900">Bienveillance</h4>
                <p className="text-slate-600">Un accompagnement humain et respectueux</p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 text-center space-y-3">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-shield-check-line text-3xl text-orange-500"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900">Confidentialité</h4>
                <p className="text-slate-600">Vos informations sont protégées et sécurisées</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-24 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold">Vous vous reconnaissez dans l'un de ces profils ?</h2>
            <p className="text-xl text-slate-300 leading-relaxed">
              N'hésitez pas à nous contacter pour échanger sur vos besoins et découvrir comment PULSAR FC peut vous accompagner dans votre parcours.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link 
                to="/contact" 
                className="px-12 py-4 bg-orange-500 text-white rounded-full font-semibold hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Nous contacter
              </Link>
              <Link 
                to="/nos-actions" 
                className="px-12 py-4 bg-white text-slate-900 rounded-full font-semibold hover:bg-slate-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Voir nos formations
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
